import u from 'umbrellajs/umbrella.esm.js';

export function initMobileMenu() {
  // Toggle
  u('.mobile-toggle').on('click', function (e) {
    e.stopPropagation();

    const wrapper = u(this).parent();
    const menu = wrapper.find('.menu-dropdown');
    const iconOpen = u(this).find('.icon-open');
    const iconClose = u(this).find('.icon-close');

    const isOpen = !menu.hasClass('hidden');

    menu.toggleClass('hidden');
    iconOpen.toggleClass('hidden');
    iconClose.toggleClass('hidden');

    u(this).attr('aria-expanded', String(!isOpen));
  });

  // Click outside
  u(document).on('mouseup', e => {
    const target = u(e.target);

    if (
      !target.closest('.menu-dropdown').length &&
      !target.closest('.mobile-toggle').length
    ) {
      u('.menu-dropdown').addClass('hidden');
      u('.mobile-toggle')
        .find('.icon-open').removeClass('hidden')
        .closest('.mobile-toggle')
        .find('.icon-close').addClass('hidden')
        .attr('aria-expanded', 'false');
    }
  });

  // Resize
  window.addEventListener('resize', () => {
    u('.menu-dropdown').addClass('hidden');
    u('.mobile-toggle')
      .find('.icon-open').removeClass('hidden')
      .closest('.mobile-toggle')
      .find('.icon-close').addClass('hidden')
      .attr('aria-expanded', 'false');   
  });
}